<template>
    <div class="cabinet__catalog-item">
        <router-link
            :to="`${isSubdomainBrand ? '/products' : '/catalog/product'}/${product.ItemID}`"
            class="cabinet__catalog-image"
        >
            <img :src="product.images.length ? product.images[0].url : null" />
        </router-link>
        <div class="cabinet__catalog-top">
            <div class="cabinet__catalog-title d-flex align-items-center">
                <a
                    v-if="product.brand.subdomain_url"
                    :href="product.brand.subdomain_url"
                    class="cabinet__catalog-title_value"
                >
                    {{ product.brand ? product.brand.BrandName : '—' }}
                </a>
                <router-link
                    v-else
                    :to="`/brands/${product.BrandID}`"
                    class="cabinet__catalog-title_value"
                >
                    {{ product.brand ? product.brand.BrandName : '—' }}
                </router-link>
            </div>
            <div class="cabinet__catalog-category truncate">
                {{ getTypeNameByID(product.TypeID) }}
            </div>
            <div class="cabinet__catalog-code truncate">
                {{
                    product.Article
                        ? `Арт. ${product.Article}`
                        : product.sets.length
                        ? ''
                        : '&nbsp;'
                }}
                <v-tooltip
                    v-if="product.sets.length"
                    class="cursor-default"
                    :class="{ 'ml-2': product.Article }"
                    title="Артикул гарнитура"
                >
                    [{{ product.sets[0].set_article }}]
                </v-tooltip>
            </div>
        </div>
        <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
            <template v-for="material of product.materials">
                <div
                    :key="material.MaterialID"
                    class="cabinet__catalog-tag"
                    :class="{ hidden: material.MaterialID == 13 }"
                >
                    <a>{{ material.Name }}</a>
                </div>
                <div
                    v-if="material.pivot && material.pivot.Fineness"
                    :key="material.pivot.ItemID"
                    class="cabinet__catalog-tag"
                >
                    <a href="javascript:void(0)">
                        {{ material.pivot.Fineness }}
                    </a>
                </div>
            </template>
        </div>
        <div class="cabinet__catalog-info">
            <template v-if="product.price_expired == false">
                <div v-if="product.Price > 0" class="cabinet__catalog-price">
                    {{ getFormattedNum(product.Price || 0) }} ₽{{ priceUnit }}
                </div>
            </template>
            <div
                v-if="parseFloat(product.Weight) > 0 && !isWatchCategory"
                class="cabinet__catalog-weight"
            >
                {{ product.Weight }} гр
            </div>
        </div>

        <adding-and-deleting-to-public-cart :item="product" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import getNameById from '@/mixins/getNameById'
import getFormattedNum from '@/utils/getFormattedNum'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'

export default {
    name: 'PublicCatalogItem',
    components: {
        AddingAndDeletingToPublicCart
    },
    mixins: [getNameById],
    props: {
        product: {
            type: Object,
            default: () => {}
        },
        isSubdomainBrand: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('types', { types: 'supplierTypes' }),
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        },
        isWatchCategory() {
            return this.product.CategoryID === 5 //Часы
        }
    },
    methods: {
        getFormattedNum,
        getTypeNameByID(id) {
            return this.types.length &&
                this.types.filter(type => type.TypeID === parseInt(id, 10))
                    .length
                ? this.types.filter(type => type.TypeID === parseInt(id, 10))[0]
                      .Name || '—'
                : '—'
        }
    }
}
</script>
